/**
 * Tokens CTA marque — source unique pour le thème MUI et AppButton.
 */
export const brandButtons = {
  primary: {
    main: '#A5765C',
    hover: '#8e6549',
    contrast: '#ffffff',
    shadow: '0 4px 12px rgba(165, 118, 92, 0.2)',
    shadowHover: '0 6px 16px rgba(165, 118, 92, 0.3)',
  },
  secondary: {
    border: '#E3D2C5',
    text: '#6C5648',
    bg: '#ffffff',
    hoverBorder: '#A5765C',
    hoverBg: 'rgba(165, 118, 92, 0.04)',
  },
  shape: {
    pillRadius: 9999,
  },
} as const;

export const brandButtonsDark = {
  secondary: {
    border: 'rgba(227, 210, 197, 0.45)',
    text: '#E9D8CC',
    bg: 'transparent',
    hoverBorder: '#C49A7C',
    hoverBg: 'rgba(165, 118, 92, 0.12)',
  },
} as const;
